'use client';

import { HStack } from '@terra/ui-styled-system';
import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { Dialog } from '../../../components/dialog';
import {
  AttachmentContextPill,
  type AttachmentContextPillModel,
} from './AttachmentContextPill';

export type ChatAttachmentPillItem = AttachmentContextPillModel;

type ChatAttachmentsPillRowProps = {
  items: ChatAttachmentPillItem[];
  onRemove?: (id: string) => void;
  removeAriaLabel: string;
};

export function ChatAttachmentsPillRow({
  items,
  onRemove,
  removeAriaLabel,
}: ChatAttachmentsPillRowProps) {
  const tCommon = useTranslations('designSystem.common');
  const [previewId, setPreviewId] = useState<string | null>(null);

  if (items.length === 0) {
    return null;
  }

  const previewItem = previewId
    ? items.find((item) => item.id === previewId)
    : undefined;

  return (
    <>
      <HStack gap={1} flexWrap="wrap" w="full" minW={0}>
        {items.map((item) => (
          <AttachmentContextPill
            key={item.id}
            attachment={item}
            removeAriaLabel={removeAriaLabel}
            onRemove={onRemove ? () => onRemove(item.id) : undefined}
            onPreview={
              item.fileType === 'IMAGE' && item.previewUrl
                ? () => setPreviewId(item.id)
                : undefined
            }
          />
        ))}
      </HStack>
      {previewItem?.previewUrl ? (
        <Dialog
          open
          onOpenChange={(open) => {
            if (!open) {
              setPreviewId(null);
            }
          }}
          title={previewItem.fileName}
          primaryAction={{
            label: tCommon('close'),
            onClick: () => setPreviewId(null),
          }}
        >
          <img
            src={previewItem.previewUrl}
            alt={previewItem.fileName}
            style={{
              maxWidth: '75vw',
              maxHeight: '70vh',
              objectFit: 'contain',
              display: 'block',
            }}
          />
        </Dialog>
      ) : null}
    </>
  );
}
